export class MockGeocodeStrategy {
  getLocalities = jasmine.createSpy('getLocalities');
  formatLocality = jasmine.createSpy('formatLocality');
}
